import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
export function Guarantee() {
  return <section className="py-20 bg-ocean-cream border-y border-gray-100" data-id="element-93">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-soft border border-gray-100 text-center" data-id="element-95">
          <div className="w-20 h-20 bg-ocean-teal-light rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-96">
            <ShieldCheck className="w-10 h-10 text-ocean-teal" data-id="element-97" />
          </div>

          <h2 className="text-3xl font-bold mb-2 uppercase tracking-tight text-gray-900" data-id="element-98">
            GARANTÍA SISTEMA 360 — 7 DÍAS
          </h2>

          <p className="text-xl text-ocean-teal font-medium mb-8" data-id="element-99">
            Abrís los tomos. Revisás los bonos. Los aplicás en tu negocio.
          </p>

          <div className="text-gray-700 text-lg leading-relaxed max-w-2xl mx-auto space-y-4" data-id="element-100">
            <p data-id="element-101">
              Si en 7 días sentís que este sistema no te ayuda a ordenar tus
              números, tus clientas o tu operación:
            </p>
            <p className="font-bold text-xl text-gray-900" data-id="element-102">
              Te devolvemos el 100%.
            </p>
            <p className="font-bold text-ocean-teal-dark" data-id="element-103">
              Sin preguntas. Sin formularios. Sin drama.
            </p>
            <p className="text-base text-gray-500 mt-6" data-id="element-104">
              La confianza que tenemos en el Sistema 360 Nail Artist nos permite
              ofrecerte esto. Riesgo cero para vos.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}